module.exports = __webpack_public_path__ + "img/pick5_blue.e3c97c83.png";